import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'

interface Options {
  crewID: string,
  start: string,
  end: string
}

export const apiLeavetNoteSearch = ({ crewID, start, end }: Options) => {
  const options = {
    method: 'GET',
    url: `${BASE_API_URL}/ref/leaveNote`,
    params: {
      crewID: crewID,
      start: start,
      end: end,
      'reqDev': 'web'
    }
  }
  return ax(options)
}